export const ACTION_GENERATION_PARUTIONS = 'generationParutions';
export const ACTION_DUPLICATION_PARUTIONS = 'duplicationParutions';
export const ACTION_MASS_MODIFICATION = 'modificationMasse';

export const TYPE_EDITION_BAT_ATTENTE_RETOUR = 'BatAttenteRetour';
export const TYPE_EDITION_RECAP_MAQUETTISTE = 'RecapitulatifMaquettiste';
export const TYPE_EDITION_REALISE = 'Realise';
export const TYPE_EDITION_RELEVE_DE_PUB = 'ReleveDePub';
export const TYPE_EDITION_RELEVE_DE_PUB_RAPPROCHE = 'ReleveDePubRapproche';
export const TYPE_EDITION_CHEMIN_FER = 'CheminFer';
export const TYPE_EDITION_CHEMIN_FER_SANS_PAGE_VIDE = 'CheminFerSansPageVide';
export const TYPE_EDITION_PARUTION_REPORTING = 'ParutionReporting';

export const EXPORT_EXCEL_PARUTION = 'parution';
export const SPECIFIQUE_HSP = 'HSP';

export const LISTE_CHOICE_EDITION_PARUTION = [
  {
    typeEdition: '',
    libelle: 'listeParution.editions.recapMaquettiste',
    typeDonnee: TYPE_EDITION_RECAP_MAQUETTISTE,
    tousProduits: false,
    afficherSurCheminDeFer: false,
  },
  {
    typeEdition: '',
    libelle: 'listeParution.editions.editionBatAttenteRetour',
    typeDonnee: TYPE_EDITION_BAT_ATTENTE_RETOUR,
    tousProduits: false,
    afficherSurCheminDeFer: false,
  },
  {
    typeEdition: '',
    libelle: 'listeParution.editions.editionChemindeFer',
    typeDonnee: TYPE_EDITION_CHEMIN_FER,
    tousProduits: false,
    extentions: ['Pdf'],
    afficherSurCheminDeFer: true,
  },
  {
    typeEdition: '',
    libelle: 'listeParution.editions.editionChemindeFerSansPageVide',
    typeDonnee: TYPE_EDITION_CHEMIN_FER_SANS_PAGE_VIDE,
    tousProduits: false,
    extentions: ['Pdf'],
    afficherSurCheminDeFer: true,
  },
  {
    typeEdition: '',
    libelle: 'listeParution.editions.editionReleveDePub',
    typeDonnee: TYPE_EDITION_RELEVE_DE_PUB,
    tousProduits: true,
    afficherSurCheminDeFer: false,
  },
  {
    typeEdition: '',
    libelle: 'listeParution.editions.editionReleveDePubRapproche',
    typeDonnee: TYPE_EDITION_RELEVE_DE_PUB_RAPPROCHE,
    tousProduits: true,
    afficherSurCheminDeFer: false,
  },
  {
    typeEdition: '',
    libelle: 'listeParution.editions.realise',
    typeDonnee: TYPE_EDITION_REALISE,
    tousProduits: true,
    afficherSurCheminDeFer: false,
  },
  {
    typeEdition: '',
    libelle: 'listeParution.editions.editionParutionReporting',
    typeDonnee: TYPE_EDITION_PARUTION_REPORTING,
    tousProduits: false,
    extentions: ['Pdf'],
    afficherSurCheminDeFer: false,
  },
];

export const DATE_ENVOI_CF = 'dateEnvoiCF';
export const DATE_ENVOI_CF_DEFINITIF = 'dateEnvoiCFDefinitif';
export const DATE_ENVOI_BAT = 'dateEnvoiBAT';
export const DATE_ENVOI_BAT_DEFINITIF = 'dateEnvoiBATDefinitif';
export const DATE_REMISE_ELT_TECH = 'dateRemiseEltTech';
export const DATE_REMISE_ELT_TECH_DEFINITIF = 'dateRemiseEltTechDefinitif';
export const DATE_PARUTION = 'dateParution';
export const DATE_PARUTION_DEFINITIF = 'dateParutionDefinitif';

export const TYPE_DATES = {
  dateEnvoiCF: DATE_ENVOI_CF,
  dateEnvoiBAT: DATE_ENVOI_BAT,
  dateRemiseEltTech: DATE_REMISE_ELT_TECH,
  dateParution: DATE_PARUTION,
};

export const TYPE_DATES_DEFINITIF = {
  dateEnvoiCF: DATE_ENVOI_CF_DEFINITIF,
  dateEnvoiBAT: DATE_ENVOI_BAT_DEFINITIF,
  dateRemiseEltTech: DATE_REMISE_ELT_TECH_DEFINITIF,
  dateParution: DATE_PARUTION_DEFINITIF,
};
